'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';
import { useMeasure } from 'react-use';

import cx from 'classnames';
import PropTypes from 'prop-types';

import ButtonCTA from 'components/ui/ButtonCTA';
import RichText from 'components/ui/RichText/Server';
import ShareButtons from 'components/ui/ShareButtons';
import SvgIcon from 'components/ui/SvgIcon';
import Text from 'components/ui/Text';

import useScrollDirection from 'hooks/useScrollDirection';
import { formatRecipeTime } from 'utils';

import { overrides } from './overrides';

import styles from './Ingredients.module.scss';

const Ingredients = ({ richText, prepTime, cookTime, serves }) => {
    const [topRef, { height: topHeight }] = useMeasure();
    const [bottomRef, { height: bottomHeight }] = useMeasure();
    const scrollDirection = useScrollDirection();

    if (richText) {
        return (
            <section className={cx(styles.root, styles[scrollDirection])}>
                <div ref={topRef} className={styles.top}>
                    <div className={styles.info}>
                        <SvgIcon className={styles.timeIcon} type="clock" />
                        <Text
                            className={styles.infoText}
                            baseTheme="labelMedium"
                            themes={{ large: 'labelLarge' }}
                        >
                            {formatRecipeTime(prepTime + cookTime)}
                        </Text>

                        <Text
                            className={styles.infoText}
                            baseTheme="labelMedium"
                            themes={{ large: 'labelLarge' }}
                        >
                            serves {serves}
                        </Text>
                    </div>
                    <Text
                        as="h3"
                        className={styles.title}
                        baseTheme="headingSmall"
                        themes={{ medium: 'headingMedium' }}
                    >
                        Ingredients
                    </Text>
                </div>
                <div
                    style={{
                        '--ingredients-height': `${topHeight + bottomHeight}px`,
                    }}
                    className={styles.ingredients}
                >
                    {richText && (
                        <RichText richText={richText} overrides={overrides} />
                    )}
                </div>
                <div ref={bottomRef} className={styles.bottom}>
                    <ButtonCTA
                        className={styles.printButton}
                        text="Print Recipe"
                        style="filled-blue-ocean"
                        onClick={() => window.print()}
                    />

                    <div className={styles.share}>
                        <Text
                            as="span"
                            baseTheme="labelMedium"
                            className={styles.shareLabel}
                        >
                            Share:{' '}
                        </Text>
                        <ShareButtons />
                    </div>
                </div>
            </section>
        );
    }

    return null;
};

Ingredients.propTypes = {
    cookTime: PropTypes.number,
    prepTime: PropTypes.number,
    richText: PropTypes.object,
    serves: PropTypes.string,
};

export default Ingredients;
